import { SpaceModel } from "../../interfaces/Space";
import ObjectAddress from "./ObjectAddress";

type Props = {
    space: SpaceModel;
}

export default function InfoMainAddress({ space }: Props) {

    const getAddress = (space: SpaceModel) => {
        if (space.mainAddress) {
            return <ObjectAddress address={space.mainAddress} />
        } else {
            return space.properties.address;
        }
    }

    return <div>{getAddress(space)}</div>
}